import { useEffect, useRef, useState } from "react";
import { Header } from "../../widgets";
import { Loader } from "../../widgets/loaders/Loader";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { getItemLocalStorage } from "../../features/webStorageSaver";
import ToastMessageContainer from "../../widgets/toastMessageContainer/ToastMessageContainer";
import { useDispatch } from "react-redux";
import { showToastMessage } from "../../stateManagement/reducers";

// Страница для восстановления пароля
export function ConfirmRegisterPage() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { dataBase, guid }: any = useParams()

    const errRef = useRef<HTMLInputElement>()
    const [loading, setLoading] = useState<any>();
    const [isSuccess, setIsSuccess] = useState<boolean>(false)
    const [isError, setIsError] = useState<boolean>(false)

    async function confirmRegistration() {
        setLoading(true)
        const fullConfig = getItemLocalStorage('fullConfig')
        const currentConfig = fullConfig[dataBase]
        let apiUrl = currentConfig?.irosRestApiUrl
        try {
            const url = `${apiUrl}/security/account/confirmEmail?guid=${guid}`;
            const response = await axios.get(url);
            const data = response.data;
            if (data.Status === 'OK') {
                setIsSuccess(true)
                setLoading(false)
            } else if (data.Error) {
                setLoading(false)
                setIsError(true)
                dispatch(showToastMessage({messageText: 'Истекло время действия ссылки для регистрации', messageType: 'error'}))
                if (errRef.current)
                    errRef.current.focus();
            }
        } catch (error: any) {
            if (error?.response?.status !== 502 && error?.response?.data?.error?.code !== 'Forbidden') {
                // отображение контейнера уведомления об ошибке
                dispatch(showToastMessage({messageText: 'Проблемы с соединением', messageType: 'error'}))
                if (errRef.current)
                    errRef.current.focus();
            }
            setLoading(false)
            setIsError(true)
        }
    }

    useEffect(() => {
        confirmRegistration()
    }, [])


    return (
        <>
            {loading ? <Loader /> : <></>}
            <div>
                <ToastMessageContainer position="bottom-center"/>
                <Header type="login" />
                <div className="login-page-back">
                    <div>
                        <div className="login-window remind">
                            <div className="login-window-top">
                                Завершение регистрации
                            </div>
                            <div className="login-window-main">
                                <div>
                                    <span className="success-message">
                                        {isError &&
                                            <span>Ошибка регистрации.</span>
                                        }
                                        {isSuccess &&
                                            <span>Ваш адрес электронной почты подтверждён. В ближайшее время администраторы системы откроют вам доступ.</span>
                                        }
                                        {(!isSuccess && !isError) &&
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                <span>Загрузка...</span>
                                            </>
                                        }
                                    </span>
                                    <button onClick={() => navigate('/')} className="back-to-main-but">На главную</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
